import { z } from "zod";
import { countCharacters } from "@root/shared/utils/countCharacters";

const PERSON_IN_CHARGE_NAME_MAX_LENGTH = 20;
const PERSON_IN_CHARGE_DETAILS_MAX_LENGTH = 300;

const createMaxLengthValidator = (maxLength: number) => {
  return (value: string | undefined): boolean => {
    if (!value) return true;
    return countCharacters(value) <= maxLength;
  };
};

const createMaxLengthErrorMessage = (maxLength: number): string => {
  return `${maxLength}文字以内で入力してください。`;
};

export const personInChargeSchema = z.object({
  personInChargeName: z
    .string()
    .optional()
    .refine(createMaxLengthValidator(PERSON_IN_CHARGE_NAME_MAX_LENGTH), {
      message: createMaxLengthErrorMessage(PERSON_IN_CHARGE_NAME_MAX_LENGTH),
    }),
  personInChargeDetails: z
    .string()
    .optional()
    .refine(createMaxLengthValidator(PERSON_IN_CHARGE_DETAILS_MAX_LENGTH), {
      message: createMaxLengthErrorMessage(PERSON_IN_CHARGE_DETAILS_MAX_LENGTH),
    }),
  employmentDate: z.date().optional(),
});

export type PersonInChargeValues = z.infer<typeof personInChargeSchema>;

export { PERSON_IN_CHARGE_NAME_MAX_LENGTH, PERSON_IN_CHARGE_DETAILS_MAX_LENGTH };
